import React from "react";

// External

// Internal
import Layout from "../../components/layout";
import SEO from "../../components/SEO";
import { CondexoPropertyManagementProjectSection } from "../../containers/projects";

const CondexoPropertyManagementProjectPage = () => {
  return (
    <Layout>
      <SEO
        title="Condexo Property Management - Projects"
        description="Reducing landlord's burden of handling properties using property management web app | Real estate industry | Year: 2019-2021 | Javascript, React, Stripe"
      />
      <CondexoPropertyManagementProjectSection />
    </Layout>
  );
};

export default CondexoPropertyManagementProjectPage;
